
  import { Vue, Component } from "vue-property-decorator";
  import MultiselectAvatarTag from "@/components/autocompleteMultiselects/MultiselectAvatarTag.vue";
  import MultiselectAvatar from "@/components/autocompleteMultiselects/MultiselectAvatar.vue";
  import DropdownFilter from "@/components/filters/DropdownFilter.vue";
  import S3Image from "@/components/common/s3-image.vue";
  import getFullName from "@/helpers/getFullName";
  import getInitials from "@/helpers/getInitials";
  import TableAvatar from "@/components/table/TableAvatar.vue";

  @Component({
    components: {
      MultiselectAvatarTag,
      MultiselectAvatar,
      DropdownFilter,
      S3Image,
      TableAvatar,
    },
  })
  export default class EmployeeMultiselect extends Vue {
    getFullName = getFullName;
    getInitials = getInitials;
  }
